var _path, _path2, _path3, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9933",
    d: "M0 0h3v.667H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .667h3v.666H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#138808",
    d: "M0 1.333h3V2H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1,
    r: 0.27,
    fill: "none",
    stroke: "#000080",
    strokeWidth: 0.035
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000080",
    strokeWidth: 0.018
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5.73v.54M1.23 1h.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.309.809.382.382m0-.382-.382.382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.365.75.27.5m.115-.385-.5.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.25.865.5.27m-.115-.385-.27.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.f7e8e7437a7520325639696349ebda1e.svg";
export { ForwardRef as ReactComponent };